import React from "react";
import TransferList from "./TransferList";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";

export default function CustomerCgSearchResult() {
	const setupState = useSelector((store) => store.scenarioSetupNew);
	const { custsCGs, selectedCustsCGs, is_customer_refresh } = setupState;

	return (
		<Box
			sx={{
				mt: 4,
				p: 2,
				border: 1,
				borderRadius: 1,
				borderColor:"#c6c6c6"
			}}
		>
			<Box sx={{ mt: 0 }}>
				<Typography
					sx={{ fontWeight: "bold" }}
					leftList={custsCGs}
					rightList={selectedCustsCGs}
				>
				</Typography>
			</Box>

			<Box sx={{ mt: 1 }}>
				<TransferList
					leftList={custsCGs}
					rightList={selectedCustsCGs}
					leftState={"custsCGs"}
					rightState={"selectedCustsCGs"}
					isCustomer = {true}
					refresh = {is_customer_refresh}
				/>
			</Box>
		</Box>
	);
}
